import React from 'react';

import cx from 'classnames';

import s from './TabSelector.module.css';
import * as t from './TabSelector.types';
import { useUnderlineStyles } from './useUnderlineStyles';

export const TabSelector = (props: t.TabSelectorProps) => {
  const { initialActiveTab = 0 } = props;
  const [activeTab, setActiveTab] = React.useState(initialActiveTab);
  const { tabsRef, underlineStyle } = useUnderlineStyles({ activeTab });

  const onTabChange = (activeTabIndex: number) => {
    setActiveTab(activeTabIndex);
    if (props.onTabChange) {
      props.onTabChange(activeTabIndex);
    }
  };

  return (
    <div>
      <div className={cx(s.tabs, props.tabsClassName)}>
        {props.tabs.map((tab, index) => (
          <div
            key={index}
            ref={(el) => (tabsRef.current[index] = el!)}
            className={cx(
              s.tab,
              { [s.disabledTab]: props.disabledTabs?.includes(index) },
              { [s.inactiveTab]: index !== activeTab },
            )}
            onClick={() => onTabChange(index)}
          >
            {tab.labelContent}
          </div>
        ))}

        <div className={s.tabUnderline} style={{ ...underlineStyle }} />
      </div>

      {props.tabs[activeTab]?.content && <div>{props.tabs[activeTab].content}</div>}
    </div>
  );
};
